const log = console.log;

const IS_TRUE = JSON.parse(localStorage.getItem("process")) || false;
const logFn = (...val) => {
    if(process.env.NODE_ENV === "development" || IS_TRUE) {
        log(...val);
    }
}
console.log = logFn;
